var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup11712762083(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.371 19.4229C20.4722 21.713 18.6239 23.6495 16.2432 23.7468C16.0679 23.7542 7.51908 23.737 7.51908 23.737C5.14989 23.9168 3.07638 22.2143 2.8895 19.9329C2.87542 19.7629 2.87926 10.5902 2.87926 10.5902C2.77431 8.29769 4.61999 6.35624 7.00198 6.25522C7.17989 6.2466 15.7171 6.26261 15.7171 6.26261C18.0979 6.08522 20.1778 7.80001 20.3621 10.0926C20.3749 10.2576 20.371 19.4229 20.371 19.4229Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 12.4748L24.4913 9.10605C25.5113 8.27105 27.0413 8.99855 27.04 10.3148L27.025 19.501C27.0238 20.8173 25.4925 21.5385 24.475 20.7035L20.375 17.3348",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25L9.64105 20.3586L18.1652 11.8338L24.9985 5",
    stroke: "#E52727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11712762083);
export default __webpack_public_path__ + "static/media/Group 1171276208 (3).e2dd6968.svg";
export { ForwardRef as ReactComponent };